import { Component, OnInit } from '@angular/core';
import { ConstantService } from 'src/app/service/constant.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.styl']
})
export class FooterComponent implements OnInit {
  // IsVerified = false;
  DisplayMessage: string;
  gameUrl = '';
  constructor(public constant: ConstantService) {
    if (sessionStorage.getItem('GameUrl')) {
      this.gameUrl = JSON.parse(sessionStorage.getItem('GameUrl'));
    }
  }

  ngOnInit() {
    const url = new URL(window.location.href);
    const Token = url.searchParams.get('Token');
    if (this.gameUrl) {
      this.gameUrl = this.gameUrl.split('?')[1];
    }
    if ((Token && Token !== '') || this.gameUrl) {
      // this.constant.IsVerified = true;
    } else {
      this.constant.IsVerified = false;
    }
  }

}
